import { useState, useEffect } from 'react';

interface PasswordStrengthProps {
  password: string;
}

export default function PasswordStrength({ password }: PasswordStrengthProps) {
  const [strength, setStrength] = useState<string>('');

  useEffect(() => {
    if (!password) {
      setStrength('');
      return;
    }
    let score = 0;
    if (password.length >= 8) score += 1;
    if (/[A-Z]/.test(password)) score += 1;
    if (/[a-z]/.test(password)) score += 1;
    if (/[0-9]/.test(password)) score += 1;
    if (/[^A-Za-z0-9]/.test(password)) score += 1;

    if (score <= 2) setStrength('Weak');
    else if (score <= 4) setStrength('Moderate');
    else setStrength('Strong');
  }, [password]);

  return (
    <div className="mt-2">
      {strength && (
        <p className={`text-sm ${
          strength === 'Weak' ? 'text-red-600' : 
          strength === 'Moderate' ? 'text-yellow-600' : 'text-green-600'
        }`}>
          Password Strength: {strength}
        </p>
      )}
    </div>
  );
}